import Vue from "vue";

const formatter = new Intl.NumberFormat("pt-PT", {
	style: "currency",
	currency: "EUR",
	maximumFractionDigits: 2,
});

const moneyFormatter = (value) => formatter.format(value);

// install the filter on the Vue
Vue.filter("money", moneyFormatter);

export default moneyFormatter;
